import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError, Observable, catchError } from 'rxjs';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { BYPASS_AUTH } from '../auth/auth-interceptor.interceptor';

@Injectable({
  providedIn: 'root',
})
export class RelayService {
  constructor(public http: HttpClient, private router: Router) {}
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  base_url = environment.apiUrl;

  createRelay(data: any): Observable<any> {
    return this.http
      .post(this.base_url + `relay`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  updateRelay(id: any, data: any): Observable<any> {
    return this.http
      .put(this.base_url + `relay/${id}`, data, {
        headers: this.headers,
      })
      .pipe(
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  // async createRelay(data: any, apiKey: string) {
  //   try {
  //     const res = await fetch(this.base_url2, {
  //       method: 'POST',
  //       context: new HttpContext().set(BYPASS_AUTH, true),
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'api-key': apiKey,
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     if (!res.ok) {
  //       throw new Error(`HTTP error! Status: ${res.status}`);
  //     }

  //     const result = await res.json();
  //     console.log(result);
  //     return result;
  //   } catch (error) {
  //     console.error('API call failed:', error);
  //   }
  // }

  // createRelay(data: any, apiKey: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     ...this.headers,
  //     'api-key': apiKey,
  //   });

  //   return this.http
  //     .post(this.base_url + `relay`, data, { headers })
  //     .pipe(
  //       catchError((error: any) => throwError(error))
  //     );
  // }

  getRelays(type: string): Observable<any> {
    return this.http.get(this.base_url + `relay?type=${type}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  getRelayById(id: string): Observable<any> {
    return this.http.get(this.base_url + `relay/${id}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
  deleteRelay(data: any): Observable<any> {
    return this.http.delete(this.base_url + `relay/${data}`).pipe(
      catchError((error: any) => {
        return throwError(error);
      })
    );
  }
}